export default {
  data: () => ({
    SET_locale: true,
    SET_appBarLogo: require('@/__vue2cmsstonevuetify/assets/img/app-bar-logo.svg'),
    SET_navigationDrawerLogo: require('@/__vue2cmsstonevuetify/assets/img/navigation-drawer-logo.svg'),
    SET_menu: [
      {
        icon: 'mdi-cog',
        title: '系統',
        menu: [
          {
            link: '/locale',
            title: '語言列表',
          },
          {
            link: '/tag',
            title: '標籤',
          },
          {
            link: '/area',
            title: '地區',
          },
          {
            title: '產業類型',
            link: '/industry_category',
          },
          {
            title: '領域',
            link: '/system_class',
          },
        ],
      },
      {
        icon: 'mdi-lifebuoy',
        title: 'SOS',
        link: '/sos_request',
      },
      // {
      //   icon: 'mdi-message-draw',
      //   title: '意見回饋',
      //   link: '/feedback',
      // },
      {
        icon: 'mdi-forum',
        title: '一般法律諮詢',
        link: '/legal_inquiry',
      },
      {
        icon: 'mdi-gavel',
        title: '法規',
        menu: [
          {
            link: '/act',
            title: '法規',
          },
          {
            title: '法規類別',
            link: '/act_type',
          },
          {
            title: '法規狀態',
            link: '/act_status',
          },
          {
            title: '法規鑑別',
            isToggle: false,
            menu: [
              {
                title: '法規鑑別列表',
                link: '/act_idtf_assignment',
              },
              {
                title: '我的法規內容格式更新作業',
                link: '/act_cnt_update',
              },
              {
                title: '我的覆核內容格式更新作業',
                link: '/act_cnt_review',
              },
              {
                title: '我的鑑別作業',
                link: '/idtf_update',
              },
              {
                title: '我的覆核鑑別作業',
                link: '/idtf_review',
              },
              {
                title: '我的總覆核鑑別作業',
                link: '/idtf_review_overall',
              },
            ],
          },
          {
            title: '法規風險燈號',
            link: '/effect',
          },
          // {
          //   title: '法規鑑別作業',
          //   link: '/',
          // },
        ],
      },
      {
        icon: 'mdi-account-multiple',
        title: '用戶',
        menu: [
          // {
          //   title: '使用者帳號',
          //   link: '/user',
          // },
          {
            title: '客戶系統管理',
            link: '/app',
          },
          // {
          //   title: '集團管理',
          //   link: '/organization',
          // },
          {
            title: '工廠管理',
            link: '/factory',
          },
          // {
          //   title: '工廠變更管理',
          //   link: '/',
          // },
          // {
          //   title: '工廠角色管理',
          //   link: '/',
          // },
          // {
          //   title: '集團角色管理',
          //   link: '/',
          // },
          {
            title: '預設工廠角色管理',
            link: '/user_factory_template_role',
          },
          // {
          //   title: '預設集團角色管理',
          //   link: '/user_organization_template_role',
          // },
          {
            title: '角色類型管理',
            link: '/role_type',
          },
          {
            title: '批次內規',
            link: '/guideline/batch',
          },
        ],
      },
      {
        icon: 'mdi-file-document-outline',
        title: '訂閱 API DEMO',
        link: '/subscription_api_demo',
      },
      {
        icon: 'mdi-laptop',
        title: '後台管理員',
        menu: [
          {
            title: '後台管理員帳號',
            link: '/admin',
          },
          {
            title: '後台活動紀錄',
            link: '/admin_log',
          },
          // {
          //   title: '後台管理員角色',
          //   link: '/',
          // },
        ],
      },
      {
        icon: 'mdi-google-translate',
        title: '介面翻譯',
        menu: [
          {
            title: '主題管理',
            link: '/topic',
          },
          {
            title: '文案管理',
            link: '/content_text',
          },
          {
            title: '翻譯管理',
            link: '/translation',
          },
        ],
      },
      {
        icon: 'mdi-new-box',
        title: 'ESGoal快報',
        link: '/ll_broadcast',
      },
      {
        icon: 'mdi-bullhorn',
        title: '新訊',
        link: '/announcement',
      },
      {
        icon: 'mdi-account-group',
        title: '聯盟',
        link: '/alliance',
      },
      {
        icon: 'mdi-account-box',
        title: '證照管理',
        menu: [
          {
            title: '證照類型',
            link: '/license_type',
          },
          {
            title: '證照公版',
            link: '/license_template',
          },
        ],
      },
      {
        icon: 'mdi-trending-up',
        title: '內訓公版',
        link: '/internal_training_template',
      },
      {
        icon: 'mdi-playlist-check',
        title: '點檢管理',
        menu: [
          {
            title: '常用選項組合公版',
            link: '/answer_setting',
          },
          {
            title: '點檢表公版',
            link: '/checklist_template',
          },
        ],
      },
      {
        icon: 'mdi-shield-check',
        title: '稽核表公版',
        link: '/audit_template',
      },
      {
        icon: 'mdi-alert',
        title: '事件類型',
        link: '/event_type',
      },
      {
        icon: 'mdi-autorenew',
        title: '變動管理',
        menu: [
          {
            title: '變動因素',
            link: '/change_item_template',
          },
          {
            title: '風險評估項目',
            link: '/risk_template',
          },
        ],
      },
      {
        icon: 'mdi-hammer-wrench',
        title: '承攬商管理',
        menu: [
          {
            title: '承攬商類型',
            link: '/contractor_type',
          },
          {
            title: '承攬商資格證公版',
            link: '/contractor_license_template',
          },
          {
            title: '承攬商簽約提醒',
            link: '/contract_reminder',
          },
          // {
          //   title: '收工檢查項目',
          //   link: '/exit_check_item_template',
          // },
        ],
      },
      {
        icon: 'mdi-link-variant',
        title: '模組頁面管理',
        link: '/module_page',
      },
      {
        icon: 'mdi-view-agenda',
        title: '議事管理',
        menu: [
          {
            title: '日期時間格式',
            link: '/date_format',
          },
          {
            title: '項目符號',
            link: '/item_label_type',
          },
          {
            title: '模板類型',
            link: '/meeting_template_type',
          },
          {
            title: '開放客制欄位',
            link: '/meeting_template_field',
          },
        ],
      },
      // {
      //   icon: 'mdi-help-circle',
      //   title: '常見問題管理',
      //   menu: [
      //     {
      //       title: '常見問題',
      //       link: '/',
      //     },
      //     {
      //       title: '常見問題類型',
      //       link: '/',
      //     },
      //   ],
      // },
      // {
      //   title: '使用條款',
      //   link: '/',
      // },
      // {
      //   title: '隱私權政策',
      //   link: '/',
      // },
      // {
      //   title: '後台IP存取設定',
      //   link: '/',
      // },
      {
        icon: 'mdi-cellphone',
        title: 'APP版本管理',
        link: '/app_version_management',
      },
      {
        icon: 'mdi-account-circle',
        title: '我的帳號設定',
        link: '/account_setting',
      },
    ],
  }),
};
